import React from 'react'
import { t } from 'i18next'
import { any, async, fromJSX, loadingAsyncState, StandardLocalWidget, unloadedAsyncState, Updater } from 'widgets-for-react'
import { donationFormRequest } from './productFormBlock.api'
import { initialFormInput, ProductFormState, validators } from './productFormBlock.state'
import { productFormBlockClasses, ProductFormBlockLayout } from './productFormBlock.layout'
import { ExpandableLayout } from '../expandableBlock/expandableBlock.layout'
import type { DP } from '../../../drupal/blockDefinitions'
import type { ModernBlock, SeoEvent } from '../../modernBlocks.state'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { parseExpandable } from '../../../utils/expandable'
import { State } from '../../../cmsPage.widget'
import { validatorResultBuilders } from '../../../../../../Shared/Frontend/validators/validatorExpr'
import { formInputWidget } from './elements/form'

export const productFormBlock: ModernBlock<ProductFormState, any, DP.ProductForm> = {
  kind: 'productFormBlock',
  render: (setRootState, rootState, blockIndex, blockProps, amountNested) =>
    productFormWidget(rootState, setRootState)(blockProps).map(u => s => u(s)),
  adapters: {
    drupal: (dpBlock: DP.ProductForm, blockIndex: number) => {
      const target = dpBlock.target.type[0].target_id
      if (target != 'product_form') return undefined

      return {
        blockIndex: blockIndex,
        text: dpBlock.target.field_body[0]?.processed,
        excludeFromPageMenu: dpBlock.target?.field_exclude_from_page_menu?.[0]?.value,
        anchorTitle: `donation-${blockIndex}`,
        submitState: unloadedAsyncState(),
        donationFormLoader: loadingAsyncState(() => donationFormRequest(dpBlock.target.field_product_form[0].target_id)),
        title: dpBlock.target.field_title ? dpBlock.target.field_title[0]?.value : t("DonationBlock:DonationForm.Title"),
        expandableItems: parseExpandable(dpBlock.target.field_expandable_content_blocks),
        input: initialFormInput,
        recaptcha: "",
        validator: validators.singleDonationValidator,
        productValidator: validators.productFormValidator,
        validatorResult: validatorResultBuilders.validating(""),
        productValidatorResult: validatorResultBuilders.validating(""),
        zipCodeLoader: unloadedAsyncState(),
      }
    }
  },
  sampleExample: [],
  seoEvents: (props, blockIndex) => [].filter((i) => i != undefined) as SeoEvent[],
  inView: {
    showAs: 'section',
    threshold: 0.1,
    triggerOnce: true,
    inViewClassName: getClassNameModern(productFormBlockClasses, 'inview', 'inview'),
    updateState: (currentInviewState, currentBlockState) => {
      return {
        ...currentBlockState,
        inviewState: currentInviewState
      }
    }
  },
  blockClassName: getClassNameModern(productFormBlockClasses, 'block', 'mb-6')
}

const productFormWidget: (rootState: State, setRootState: (_: Updater<State>) => void) => StandardLocalWidget<ProductFormState> = (rootState, setRootState) => s => {
  return any<Updater<ProductFormState>>([
    async(s.donationFormLoader).map(u => s1 => {
      const updatedLoader = u(s1.donationFormLoader)
      return { ...s1, donationFormLoader: updatedLoader }
    }),
    async<{}>(s.submitState)
      .map<Updater<ProductFormState>>(u => os => {
        let ns = { ...os }
        const nas = u(os.submitState)
        ns.submitState = nas
        return ns
      }),
    fromJSX(setState => {
      return <ProductFormBlockLayout.Container>
        <ProductFormBlockLayout.Form title={s.title}>
          {formInputWidget(s).run(setState)}
        </ProductFormBlockLayout.Form>
        <ProductFormBlockLayout.Wrapper state={rootState}>
          <ProductFormBlockLayout.Content text={s.text ? s.text : ''}>
            <ExpandableLayout.Items
              items={s.expandableItems}
              rootState={rootState}
              setRootState={setRootState}
            />
          </ProductFormBlockLayout.Content>
        </ProductFormBlockLayout.Wrapper>
      </ProductFormBlockLayout.Container>
    })
  ])
}
